import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'b2b.requestAccess.title',
		defaultMessage: 'Request Access',
		description: "Title for page to request access from a user's HR admin",
	},
	instructions: {
		id: 'b2b.requestAccess.instructions',
		defaultMessage:
			'If you don’t know your {uniqueId} provided by {partnerName}, enter as much information as possible so your HR Administrator can verify your request.',
		description: 'Instructions for how to request access from HR Admin',
	},
	errorRequestAccess: {
		id: 'b2b.requestAccess.errorRequestAccess',
		defaultMessage:
			'Oops! There was an error during redemption. Please fill out the form below to request access.',
		description: 'Indicates the user should fill out the form to request access.',
	},
});
